import { styled } from '@mui/material'
import { UploadSimpleIcon } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { TinyButton } from 'ComponentLibrary/src/piazza/buttons/TinyButton/TinyButton'

export type PlaceholderProps = {
    width: number
    height: number
    imageSrc: string
    onClick: () => void
}

export const userText = {
    uploadPicture: 'Titelbild hochladen',
}

export function TitleImagePlaceholder({ width, height, imageSrc, onClick }: PlaceholderProps) {
    return (
        <Container $width={width} $height={height} $imageSrc={imageSrc} onClick={onClick}>
            <TinyButton leftIcon={<UploadSimpleIcon />} label={userText.uploadPicture} onClick={() => {}} />
        </Container>
    )
}

const Container = styled('div', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $width: number; $height: number; $imageSrc: string }>`
    border-radius: ${tokens.SizingCornerM};
    width: ${(props) => `${props.$width}px`};
    height: ${(props) => `${props.$height}px`};
    background-size: cover;
    background-image: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${(props) => props.$imageSrc});
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
`
